import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import { TUserEntry } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetApprovalData = async ({
  createdFromType,
  limit
}: {
  createdFromType: string;
  limit: number;
}): Promise<
  | {
      data: TUserEntry[];
      status: string;
      code: Ti18nKeys;
    }
  | {
      data: [];
      status: string;
      code: Ti18nKeys;
    }
> => {
  const adminId = getCorePersonalStore().user.get().id;
  const { status, data, et3Error } = await post<TUserEntry[]>(
    `approveReject/getApprovalData`,
    {
      createdFromType,
      limit,
      adminId
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
